import React, { Component } from 'react';
import { CourseListing } from './courseListing';
import { SearchBar } from './searchBar';
import CreateCoursePlan from './createCoursePlan/CreateCoursePlan';
import Pagination from '../../../common/Pagination';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  WithStyles,
  createStyles
} from '@material-ui/core';
import NoContent from './NoContent';
const styles = (theme: Theme) => createStyles({
  managePagination: {
    '&>:first-child': {
      '&>:first-child': {
        '&>:first-child': {
          marginTop: 0,
        }
      }
    }
  }
});
interface CoursePlanProps extends WithStyles<typeof styles> {
  classes: any,
}
interface CoursePlanProps {
  content: any,
  totalPages: number,
  pageNumber: number,
  handlePageChange?: Function,
  handleComponentSwitching?: Function,
  courseData?: any,
  handleOnSelect?: Function,
  handleNoContent?: boolean,
  requiredSaveButton?: boolean,
  match?: any,
  classes: any,
  handleIsSearchQueryTouched: Function;
  isSearchQuery?: boolean,
}
interface CoursePlanStates {
  currentPage: number,
  totalPages: number,
}

class CoursePlan extends Component<CoursePlanProps, CoursePlanStates> {
  constructor(props: CoursePlanProps) {
    super(props);
    this.state = {
      currentPage: this.props.pageNumber,
      totalPages: this.props.totalPages
    }
  }
  handleChange = (currentPage: number, totalPages: number) => {
    this.setState({
      currentPage,
      totalPages
    }, () => {
      const { handlePageChange } = this.props;
      const newPage = currentPage;
      handlePageChange && handlePageChange({ newPage });
    })
  }

  render = () => {
    const { classes } = this.props;
    const { content = [], totalPages, handlePageChange, handleComponentSwitching, handleOnSelect } = this.props;
    const { currentPage = 0 } = this.state;
    //console.log(':::::::::::::::::;;;;search Query::::::::::::',this.props.isSearchQuery);
    return (
      <div>
        <CreateCoursePlan
          handleComponentSwitching={handleComponentSwitching}
          handleNoContent={true}
        />
        <SearchBar
          handleIsSearchQueryTouched={this.props.handleIsSearchQueryTouched}
          handlePageChange={handlePageChange}
        />
        {(content && !Boolean(content.length) && this.props.isSearchQuery) ?
          (<NoContent noData={true} />) :
          ( 
            <>
            <CourseListing
              course={content}
              currentPage={currentPage}
              handleComponentSwitching={handleComponentSwitching}
              handleOnSelect={handleOnSelect}
            />
            <Grid container className={classes.managePagination} style={{ paddingRight: '30px', paddingBottom: '100px' }}>
              <Pagination
                totalPages={totalPages}
                onPageChange={this.handleChange}
              />
            </Grid>
            </>
          )}  
      </div>
    );
        
          }
        
        }
        // @ts-ignore
        
        export default withStyles(styles)(CoursePlan);
